import { CircularProgress, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useSupabaseCallback } from "../../../../../server/supabase/hooks";
import { XCircle } from "../../../../../styles/icons/x-circle";
import { SupabaseCustomEmailDomainService } from "../../server/supabase-custom-email-domain-service";

import type { Database } from "../../../../../__definitions__/database-definitions";
import type { CustomEmailDomain } from "../../server/supabase-custom-email-domain-service";
import type { FC } from "react";

export const DeleteButton: FC<{
  customEmailDomain: CustomEmailDomain;
  onDelete: () => void;
}> = ({ customEmailDomain, onDelete }) => {
  const [removing, setRemoving] = useState(false);

  const handleDelete = useSupabaseCallback(
    async (
      { supabase },
      emailDomain: Database["public"]["Tables"]["custom_email_domain"]["Row"],
    ): Promise<void> => {
      setRemoving(true);

      const error = await new SupabaseCustomEmailDomainService(supabase).delete(emailDomain.id);

      if (!error) {
        toast.success(`${emailDomain.domain} deleted successfully.`);
        onDelete();
      } else {
        toast.error(`Something went wrong when deleting ${emailDomain.domain}`);
        setRemoving(false);
      }
    },
    [onDelete],
  );

  return (
    <GridActionsCellItem
      key="delete"
      icon={
        <Tooltip title={`Delete ${customEmailDomain.domain}`} placement="right">
          {removing ? (
            <CircularProgress size="small" />
          ) : (
            <XCircle data-testid="XCircleIcon" fontSize="small" />
          )}
        </Tooltip>
      }
      label={`Delete ${customEmailDomain.domain}`}
      aria-label={`Delete ${customEmailDomain.domain}`}
      showInMenu={false}
      onClick={() => {
        void handleDelete(customEmailDomain).catch(console.error);
      }}
    />
  );
};
